import script from "./MediaCompare.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaCompare.vue?vue&type=script&setup=true&lang=js"

import "./MediaCompare.vue?vue&type=style&index=0&id=8b513fa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b513fa2"]])

export default __exports__